import { ControlType, Property, PropertyType } from '../../../base/types';
import { FC, useCallback } from 'react';
import { ICalendarOptions, IControlAttributes } from '../../../base/models';

import { Calendar } from './Calendar';
import { DesignerMode } from '../../types';
import { EventDataProvider } from './EventDataProvider';
import { MUIIcon } from '../../../widgets';
import { Registry } from '../../../base/register';
import clsx from 'clsx';
import { useDesignContext } from '../../../providers';
import { useGetProperties } from '../../../base/hooks';

export const CalendarComponent: FC<IControlAttributes> = ({
    control, children, className
}) => {
    const { control: { designerMode } } = useDesignContext()
    const { properties } = useGetProperties({ bindings: control.bindings });
    const calendarOptions: ICalendarOptions | undefined = properties[Property.CalendarOptions]
    const classNamesExpr: string | undefined = properties[Property.ClassNamesExpr]

    const getCalendarDesigner = useCallback(() => {
        if (designerMode !== DesignerMode.Draft)
            return <></>

        return (<div className={clsx("card border border-info rounded-0")}>
            <div className="card-header min-h-5px px-0 rounded-0 border-info">
                <div className="d-flex flex-wrap align-items-center gap-2">
                    <div className="badge badge-info m-0 rounded-0 fs-9 px-1">
                        <MUIIcon iconName="CalendarMonthOutlined" className="me-1" />
                        <div className="pe-2">Calendar Component</div>
                    </div>
                </div>
            </div>
            <div className="card-body px-0 py-0 my-0">
                <EventDataProvider entity={calendarOptions?.entity}>
                    {children}
                </EventDataProvider>
            </div>
        </div>
        )

    }, [calendarOptions, children, designerMode])

    const renderCalendar = useCallback(() => {
        if (designerMode !== DesignerMode.View || !calendarOptions)
            return <></>

        return <Calendar
            calendarOptions={calendarOptions}
            eventClassNamesExpr={classNamesExpr}
            className={className}>
            {children}
        </Calendar>
        // eslint-disable-next-line
    }, [designerMode, calendarOptions, classNamesExpr])

    return (
        <div className={clsx(className)}>
            {getCalendarDesigner()}
            {renderCalendar()}
        </div>
    );
}

Registry.addControl({
    id: "c14d5d07-85df-4b03-89fd-42e09866f7af",
    name: "Calendar",
    type: ControlType.Calendar,
    properties: [
        { id: Property.CalendarOptions, name: 'Event Source', type: PropertyType.CalendarOptions },
        { id: Property.ClassNamesExpr, name: 'Event Color Expr.', type: PropertyType.String },
    ],
    component: CalendarComponent,
})
